import React, { useEffect, useState } from "react";
import uploadArrow from "../../assets/images/upload-arrow.svg";
import camera from "../../assets/images/camera.svg";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { useFormik } from "formik";
import axios from "axios";
import { IBankBranch } from "../../models/IEnums.model";
import { baseUrl } from "../../utils/baseUrl";
import * as toast from "../../utils/makeToast";
import closeIcon from "../../assets/images/close-icon.svg";
import { getLocalStorageItem } from "../../utils/localStorage";
import "react-html5-camera-photo/build/css/index.css";
import { trimImageURI } from "../../utils/imageUpload";
import {
  accountOpeningSteps,
  MAX_FILE_UPLOAD_SIZE_FIGURE,
  MAX_FILE_UPLOAD_SIZE_TEXT,
  minorDocsInitialState,
} from "../../utils/constants";
import Select from "react-select";
import "youverify-web-sdk";
import FileUpload from "../FileUpload";
import Loader from "../Loader";
import UploadSignatureCard from "../UploadSignatureCard";
import DocUpload from "../DocUpload";
import CustomModal from "../Modal/CustomModal";
import SignaturePad from "../SignaturePad";
import RadioBtn from "../../assets/icons/RadioBtn";
import apiHooks from "../../customHooks/apis";
import FormHelperText from "../FormHelperText";
import {
  extractValuesFromObj,
  returnConfigVariable,
} from "../../utils/helpers";
import { minorDocsValidationSchema } from "../../utils/validationSchemas";
import useUserValidated from "../../customHooks/useUserValidated";
import ImageUploadAndLivePhoto from "../ImageUploadAndLivePhoto";
import { string } from "yup";

function UploadDocumentMinorSavingsDialog(props: any) {
  const dispatch = useDispatch();
  const { useUploadMinorDocs, useUploadFile, useUserDetails } = apiHooks;
  const { handleUploadFile, uploadingFile } = useUploadFile();
  const { handleUploadMinorDocs, uploadingMinorDocs } = useUploadMinorDocs();
  const { userDetails, handleUpdateUserDetails } = useUserDetails();
  const { isValidated, isValid } = useUserValidated();
  const [bankBranches, setBankBranches] = useState<IBankBranch[]>([]);
  const [updating, setUpdating] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const [selectedBranch, setSelectedBranch] = useState<any>();
  const [mappedBranches, setMappedBranches] = useState([]);

  const [signatureImageUrl, setSignatureImageUrl] = useState("");
  const [idCardUrl, setIdCardUrl] = useState("");
  const [minorImageUrl, setMinorImageUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [minorIdentityUrl, setMinorIdentityUrl] = useState("");
  const [utilityBillImageUrl, setutilityBillImageUrl] = useState("");

  const [signatureImageBase64, setSignatureImageBase64] = useState("");
  const [idCardBase64, setIdCardBase64] = useState("");
  const [minorImageBase64, setMinorImageBase64] = useState("");
  const [imageBase64, setImageBase64] = useState("");
  const [minorIdentityBase64, setMinorIdentityBase64] = useState("");
  const [utilityBillImageBase64, setUtilityBillImageBase64] = useState("");
  const [signature, setSignature] = useState<{ canvas: string; input: string }>(
    {
      canvas: "",
      input: "",
    },
  );
  const [openSignatureCanvas, setOpenSignatureCanvas] =
    useState<boolean>(false);
  const [settingSignatureImage, setSettingSignatureImage] =
    useState<boolean>(false);
  const [settingIdCardImage, setSettingIdCardImage] = useState<boolean>(false);
  const [settingMinorImage, setSettingMinorImage] = useState<boolean>(false);
  const [settingImage, setSettingImage] = useState<boolean>(false);
  const [settingMinorIdentityImage, setSettingMinorIdentityImage] =
    useState<boolean>(false);
  const [settingutilityBillImage, setSettingUtilityBillImage] =
    useState<boolean>(false);
  const [userExistingDetails, setUserExistingDetails] = useState<any>();
  const [bvnValidationData, setBvnValidationData] = useState(
    getLocalStorageItem("bvnValidationData"),
  );

  const [showCamera, setShowCamera] = useState<boolean>(false);
  const [livePictureDocumentName, setLivePictureDocumentName] =
    useState<string>("");
  const formik = useFormik({
    initialValues: minorDocsInitialState,
    validationSchema: minorDocsValidationSchema.shape({
      imageUrl: isValid
        ? string().notRequired()
        : string().required("Image is required"),
    }),
    validateOnMount: true,
    onSubmit: handleUploadMinorDocs,
  });

  const goToStep = (step: any) => {
    handleUpdateUserDetails(formik.values);
    if (step === "update-detail") {
      localStorage.setItem("previous-screen", "document-upload");
    }
    dispatch(setAccountOpeningStep(step));
  };
  const isParent = userDetails.relationship?.toLowerCase() === "parent";
  let fileUploadObj: any;

  const getBankBranches = () => {
    axios
      .get(`${baseUrl}Enum/BranchCodeList`)
      .then((response) => {
        setBankBranches(response.data);

        let tempBranches = response.data;
        tempBranches = response.data.map((branch: IBankBranch) => {
          return {
            label: branch.branch,
            value: branch.brancH_CODE,
          };
        });
        setMappedBranches(tempBranches);
      })
      .catch((err) => {});
  };

  const handleSelectBranch = (data: any) => {
    setSelectedBranch(data);
  };

  const getExistingDetails = () => {
    axios
      .get(`${baseUrl}MinorSavings/existingDetails?bvn=${userDetails.bvn}`)
      .then((response) => {
        setUserExistingDetails(response?.data);
      })
      .catch((err) => {});
  };

  const uploadDcouments = (values: any) => {
    let uploadDocumentPayload = {
      id: getLocalStorageItem("minorId"),
      // signatureUrl: trimBase64ImgUrl(signatureImageUrl),
      // idCardUrl: trimBase64ImgUrl(idCardUrl),
      // minorImageUrl: trimBase64ImgUrl(minorImageUrl),
      // imageUrl: trimBase64ImgUrl(imageUrl),
      // minorIdentityUrl: trimBase64ImgUrl(minorIdentityUrl),
      signatureUrl: signatureImageUrl,
      utilityBill: utilityBillImageUrl,
      idCardUrl: idCardUrl,
      minorImageUrl: minorImageUrl,
      imageUrl: imageUrl,
      minorIdentityUrl: minorIdentityUrl,
      // branchOfDomiciliation: +values.branchOfDomiciliation,
      branchOfDomiciliation: +selectedBranch?.value,

      accountTypecode: localStorage.getItem("altFinanceGlCode"),
      accountTypeName: localStorage.getItem("altFinanceAccountType"),

      occupationName: "",
      isFlagged: bvnValidationData.isFlagged,
      termsCondition: true,
      debitCardValueAddedService:
        typeof values.debitCardValueAddedService == "boolean"
          ? !values.debitCardValueAddedService
          : true,
      debitCardDeliveryAddress: values.debitCardDeliveryAddress,
      // debitCardValueAddedService: typeof values.debitCardValueAddedService == 'boolean' ? !values.debitCardValueAddedService : true,
    };
    if (!uploadDocumentPayload.signatureUrl) {
      toast.errorToast("Please provide a signature");
      return;
    }
    if (!uploadDocumentPayload.idCardUrl) {
      toast.errorToast("Please provide an ID card");
      return;
    }
    if (!uploadDocumentPayload.minorImageUrl) {
      toast.errorToast("Please provide a picture");
      return;
    }
    if (!uploadDocumentPayload.utilityBill) {
      toast.errorToast("Please provide a Utility Bill");
      return;
    }
    if (!uploadDocumentPayload.imageUrl) {
      toast.errorToast("Please provide a picture");
      return;
    }
    if (!uploadDocumentPayload.minorIdentityUrl) {
      toast.errorToast("Please provide an identity document");
      return;
    }
    if (!uploadDocumentPayload.branchOfDomiciliation) {
      toast.errorToast("Please select a branch of account domiciliation");
      return;
    }
    if (!values.terms) {
      toast.errorToast("Please accept terms and conditions");
      return;
    }

    // return
    setUpdating(true);
    axios
      .post(`${baseUrl}MinorSavings/documentupload`, uploadDocumentPayload)
      .then((response) => {
        setUpdating(false);
        if (
          response?.data[0]?.responseMessage ==
          "Means Of Id Number has been used, Kindly use another means of Identification number"
        ) {
          toast.errorToast("Something went wrong");
          return;
        }
        if (!response?.data?.isSuccess) {
          toast.errorToast(response?.data?.message);
          return;
        }
        localStorage.setItem(
          "generatedAccountNumber",
          response?.data?.obj?.accountNo,
        );
        dispatch(setAccountOpeningStep("account-opening-success"));
      })
      .catch((err) => {
        setUpdating(false);
        toast.errorToast("Something went wrong");
        // toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
      });
  };

  useEffect(() => {
    getBankBranches();
    getExistingDetails();
  }, []);

  const uploadImage = (payload: any, type: string) => {
    if (type == "parentSignature") {
      setSignatureImageBase64(payload.postedFilebase64);
      setSettingSignatureImage(true);
    }
    if (type === "utilityBill") {
      setUtilityBillImageBase64(payload.postedFilebase64);
      setSettingUtilityBillImage(true);
    }
    if (type == "minorSelfie") {
      setMinorImageBase64(payload.postedFilebase64);
      setSettingMinorImage(true);
    }
    if (type == "parentPicture") {
      setImageBase64(payload.postedFilebase64);
      setSettingImage(true);
    }
    if (type == "parentFrontPageId") {
      setIdCardBase64(payload.postedFilebase64);
      setSettingIdCardImage(true);
    }
    if (type == "minorIdentity") {
      setMinorIdentityBase64(payload.postedFilebase64);
      setSettingMinorIdentityImage(true);
    }

    // return
    axios
      .post(`${baseUrl}Authentication/UploadFile`, payload)
      .then((response) => {
        if (type == "parentSignature") {
          setSignatureImageUrl(response.data?.id);
          setSettingSignatureImage(false);
          // setSignatureImageUrl('https://k2testcontainer4.blob.core.windows.net/testcontainer1/NEWACCOUNTOPENING/FILE/OnlineAccountBuild01%5COnlineAccountBuild01/bfbd0c59-462c-4072-b7ec-582a89810f76image.jpeg')
        } else if (type == "utilityBill") {
          setutilityBillImageUrl(response.data?.id);
          setSettingUtilityBillImage(false);
        } else if (type == "minorSelfie") {
          setMinorImageUrl(response.data?.id);
          setSettingMinorImage(false);
          // setMinorImageUrl('https://k2testcontainer4.blob.core.windows.net/testcontainer1/NEWACCOUNTOPENING/FILE/OnlineAccountBuild01%5COnlineAccountBuild01/bfbd0c59-462c-4072-b7ec-582a89810f76image.jpeg')
        } else if (type == "parentPicture") {
          setImageUrl(response.data?.id);
          setSettingImage(false);
          // setImageUrl('https://k2testcontainer4.blob.core.windows.net/testcontainer1/NEWACCOUNTOPENING/FILE/OnlineAccountBuild01%5COnlineAccountBuild01/bfbd0c59-462c-4072-b7ec-582a89810f76image.jpeg')
        } else if (type == "parentFrontPageId") {
          setIdCardUrl(response.data?.id);
          setSettingIdCardImage(false);
          // setIdCardUrl('https://k2testcontainer4.blob.core.windows.net/testcontainer1/NEWACCOUNTOPENING/FILE/OnlineAccountBuild01%5COnlineAccountBuild01/bfbd0c59-462c-4072-b7ec-582a89810f76image.jpeg')
        } else if (type == "minorIdentity") {
          setMinorIdentityUrl(response.data?.id);
          setSettingMinorIdentityImage(false);
          // setMinorIdentityUrl('https://k2testcontainer4.blob.core.windows.net/testcontainer1/NEWACCOUNTOPENING/FILE/OnlineAccountBuild01%5COnlineAccountBuild01/bfbd0c59-462c-4072-b7ec-582a89810f76image.jpeg')
        }
      })
      .catch((err) => {
        setSettingSignatureImage(false);
        setSettingMinorImage(false);
        setSettingImage(false);
        setSettingIdCardImage(false);
        setSettingMinorIdentityImage(false);
        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message,
        );
      });
  };

  const handleSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        let fileReaderResult = fileReader.result?.toString();
        return resolve(fileReaderResult);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleUploadESignature = (
    postedFilebase64: string,
    documentName: string,
    filetype: string,
    objectUrl: string,
  ) => {
    setSignature((prev) => ({ ...prev, canvas: objectUrl }));
    setOpenSignatureCanvas(false);
    handleUploadFile({ postedFilebase64, filetype, documentName }, (url) =>
      formik.setFieldValue("signatureUrl", url),
    );
  };

  const handleFileUpload = async (e: any, type: string) => {
    const file = e.target.files[0];
    let fileSize = file.size / 1000;
    const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      toast.errorToast("Only image (JPEG, PNG) or PDF files are allowed.");
      return;
    }
    if (fileSize > MAX_FILE_UPLOAD_SIZE_FIGURE) {
      toast.errorToast(
        `File size should be less than ${MAX_FILE_UPLOAD_SIZE_TEXT}`,
      );
      return;
    }
    let base64: any;

    convertToBase64(file).then((res) => {
      base64 = res;
      fileUploadObj = {
        postedFilebase64: res,
        documentName: type,
        filetype: file.type.split("/")[1],
      };
      handleSubmit(type);
    });
  };

  const clearImage = (type: any) => {
    if (type == "parentSignature") {
      setSignatureImageUrl("");
    }
    if (type == "minorSelfie") {
      setMinorImageUrl("");
    }
    if (type == "parentPicture") {
      setImageUrl("");
    }
    if (type == "parentFrontPageId") {
      setIdCardUrl("");
    }
    if (type == "minorIdentity") {
      setMinorIdentityUrl("");
    }
    if (type === "utility-bill") {
      setutilityBillImageUrl("");
    }
  };

  const toggleCamera = (type: string, value: boolean) => {
    setLivePictureDocumentName(type);
    setShowCamera(value);
  };

  const handleTakePhoto = (dataUri: any) => {
    let res = trimImageURI(dataUri);
    setImageUrl("data:image/jpg;base64," + res);
    setShowCamera(false);
    fileUploadObj = {
      // postedFilebase64: res,
      postedFilebase64: dataUri,
      documentName: livePictureDocumentName,
      filetype: "png",
    };
    handleSubmit(livePictureDocumentName);
    setShowCamera(false);
  };

  const handleCameraError = (error: any) => {
    toast.errorToast("Something went wrong, please try again");
  };

  const handleCameraStart = () => {
    //
  };

  const handleCameraStop = () => {
    //
  };

  const [loading, setLoading] = useState(false);

  const logSuccessPayload = {
    name: `${userDetails.firstName} ${userDetails.lastName}`,
    bvn: `${userDetails.bvn}`,
    dateOfBirth: userDetails.dateOfBirth,
    isSuccess: true,
  };

  const logSuccessEndpoint = () => {
    setLoading(true);
    axios
      .post(`${baseUrl}Authentication/LogLiveness`, logSuccessPayload)
      .then((response) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const logFailurePayload = {
    name: `${userDetails.firstName} ${userDetails.lastName}`,
    bvn: `${userDetails.bvn}`,
    dateOfBirth: userDetails.dateOfBirth,
    isSuccess: false,
  };

  const logFailureEndpoint = () => {
    setLoading(true);
    axios
      .post(`${baseUrl}Authentication/LogLiveness`, logFailurePayload)
      .then((response) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const radioBtnState = (state: boolean) => {
    return typeof formik.values.handoverAccount === "string" ? false : state;
  };

  const LivenessCheckClick = () => {
    // Initialize the Youverify Liveness Check module
    //@ts-ignore
    const YVSDK = window.YouverifySDK;

    const livenessCheckModule = new YVSDK.liveness({
      publicMerchantKey: returnConfigVariable(
        "REACT_APP_YOUVERIFY_PUBLIC_MERCHANT_KEY",
      ),
      dev: false,
      personalInformation: {
        firstName: `${userDetails.firstName}`,
      },
      appearance: {
        greeting:
          "We will need to perform a liveness test. It will only take a moment.",
        actionText: "Perform Liveness Test",
        buttonBackgroundColor: "#46B2C8",
        buttonTextColor: "#ffffff",
        primaryColor: "#46B2C8",
      },
      onSuccess: (data) => {
        logSuccessEndpoint();
        toggleCamera("parentPicture", true);
        // Handle successful liveness check, e.g., update UI or send data to the server
      },
      onFailure: () => {
        logFailureEndpoint();

        // Handle liveness check failure
      },
      onClose: () => {
        // Handle modal closure
      },
    });

    try {
      // Initialize the Liveness Check module
      livenessCheckModule.initialize();

      // Start the liveness check process when the component mounts
      livenessCheckModule.start();
    } catch (error) {
      console.error("Error initializing Liveness Check:", error);
      // Handle initialization error
    }

    // Cleanup function to be called when the component unmounts
    return () => {
      // You can add cleanup logic here if needed
    };
  };

  useEffect(() => {
    const accountTypeName = localStorage.getItem("altFinanceAccountType") || "";
    const accountTypecode = localStorage.getItem("altFinanceGlCode") || "";
    formik.setValues({
      ...minorDocsInitialState,
      ...extractValuesFromObj(minorDocsInitialState, userDetails),
      accountTypecode,
      accountTypeName,
      minorIdentityUrl: userDetails.minorIdentityUrl || "",
      imageUrl: localStorage.getItem("userImage") || "",
    });
  }, [userDetails]);
  return (
    <div>
      {loading && <Loader />}
      <form onSubmit={formik.handleSubmit}>
        <div className=" card-form pl-1 pr-1 ">
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-5">
              Document upload
            </h4>
            <p className="text-center">
              <small>
                The file format should be JPEG, PNG or PDF (max size:2mb)
              </small>
            </p>
            <FormHelperText />
            <div>
              <div className="d-flex flex-column flex-lg-row gap-3 mr-3 mb-3 mt-3 align-items-end">
                <div className="d-flex flex-column flex-lg-row w-100 align-items-end gap-2">
                  <div className="w-lg-50 w-100">
                    <UploadSignatureCard
                      required
                      uploading={uploadingFile}
                      label="Draw/Upload Signature"
                      show={!signature.input}
                      onClickCard={() => setOpenSignatureCanvas(true)}
                      imageUrl={signature.canvas}
                      handleRemoveFile={(canvas) => {
                        setSignature((prev) => ({ ...prev, canvas }));
                        formik.setFieldValue("signatureUrl", canvas);
                      }}
                      disabled={isUploading}
                    />
                  </div>
                  <div className="w-100 w-lg-50">
                    <DocUpload
                      name="signatureUrl"
                      required
                      show={!signature.canvas}
                      getFileUrl={(name, url) => {
                        setSignature((prev) => ({ ...prev, input: url }));
                        formik.setFieldValue(name, url);
                      }}
                      disabled={uploadingFile}
                      setIsUploading={setIsUploading}
                    />
                  </div>
                </div>
                <ImageUploadAndLivePhoto
                  getFileUrl={(url) => formik.setFieldValue("imageUrl", url)}
                />
              </div>
              <div className="row mr-3 mb-3 align-items-end">
                <div className="col-lg-6">
                  <DocUpload
                    name="utilityBill"
                    required
                    label="Upload utility bill (not older that 3 months)"
                    show
                    getFileUrl={formik.setFieldValue}
                  />
                </div>
                <div className="col-lg-6">
                  <DocUpload
                    name="minorIdentityUrl"
                    required={!isParent}
                    label="Proof of guardianship (mandatory for non Biological Parent)"
                    show
                    getFileUrl={formik.setFieldValue}
                    bottomText=""
                    errorMessage=""
                  />
                </div>
              </div>
              <div className="d-flex flex-column gap-2  w-auto mt-4">
                <small className="fw-medium small_text">
                  Do you want to Automatically handover the account when the
                  minor turns 18
                </small>
                <div className="w-50 d-flex justify-content-between">
                  <span className="w-50 d-flex gap-2 fs-6 fw-medium">
                    <RadioBtn
                      color="#181717"
                      checked={radioBtnState(!!formik.values.handoverAccount)}
                      onClickCheck={() =>
                        formik.handleChange({
                          target: {
                            name: "handoverAccount",
                            value: true,
                          },
                        })
                      }
                    />
                    Yes
                  </span>
                  <span className="w-50 d-flex gap-2 fs-6 fw-medium">
                    <RadioBtn
                      color="#181717"
                      checked={radioBtnState(!formik.values.handoverAccount)}
                      onClickCheck={() =>
                        formik.handleChange({
                          target: {
                            name: "handoverAccount",
                            value: false,
                          },
                        })
                      }
                    />
                    No
                  </span>
                </div>
              </div>{" "}
            </div>
            <div className="row mr-3 mb-3 d-none">
              {!minorImageUrl ? (
                <div className="col-lg-6">
                  <div className="col-md-6">
                    <label
                      htmlFor="firstname"
                      className="label_text2 d-inline text-nowrap font-weight-bold"
                    >
                      Upload selfie of minor
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <label className="cursor-pointer" htmlFor="minorSelfie">
                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                        {settingMinorImage ? (
                          <div className="center-v">
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          </div>
                        ) : (
                          <React.Fragment>
                            <p className="label_text">
                              Click or drag <br /> and drop file
                            </p>
                            <img
                              className="img-fluid"
                              src={uploadArrow}
                              alt=""
                            />
                          </React.Fragment>
                        )}
                      </div>
                      <input
                        onChange={(e) => handleFileUpload(e, "minorSelfie")}
                        id="minorSelfie"
                        className="input-file-type"
                        type="file"
                        name="file"
                        accept="image/png, image/jpg, image/jpeg"
                      />
                    </label>
                  </div>
                </div>
              ) : (
                ""
              )}

              {minorImageUrl ? (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("minorSelfie")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {minorImageUrl && (
                          <img
                            src={minorImageBase64}
                            width="70%"
                            height="120px"
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* ----------------- */}

              {!imageUrl ? (
                <React.Fragment>
                  <div className="col-xl-3">
                    <div className="col-md-3">
                      <label
                        htmlFor="firstname"
                        className="label_text2 text-nowrap font-weight-bold"
                      >
                        Take/Upload live picture of parent or guardian
                        <span className="text-danger">*</span>
                      </label>
                      <br />
                      <label className="cursor-pointer" htmlFor="parentPicture">
                        <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2">
                          {settingImage ? (
                            <div className="center-v">
                              <div
                                className="spinner-border text-danger"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            </div>
                          ) : (
                            <React.Fragment>
                              <p className="label_text">
                                Click or drag <br /> and drop file
                              </p>
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </React.Fragment>
                          )}
                        </div>
                        <input
                          onChange={(e) => handleFileUpload(e, "parentPicture")}
                          id="parentPicture"
                          className="input-file-type"
                          type="file"
                          name="file"
                          accept="image/png, image/jpg, image/jpeg"
                        />
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="col-md-3 mt-4">
                      {/* <div className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2" onClick={() => toggleCamera('parentPicture', true)}> */}
                      <div
                        className="pic_upload d-flex justify-content-between pt-3 pr-3 px-2"
                        onClick={LivenessCheckClick}
                      >
                        <p className="label_text">
                          Take live
                          <br />
                          picture
                        </p>
                        <img className="img-fluid" src={camera} alt="" />
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}

              {imageUrl ? (
                <div className="col-md-6">
                  {settingImage ? (
                    <div className="center-v">
                      <div className="spinner-border text-danger" role="status">
                        <span className="sr-only"></span>
                      </div>
                    </div>
                  ) : (
                    <div className="img-upload-success-div">
                      <div className="close-icon-signature-div">
                        <div className="close-icon-img cursor-pointer">
                          <img
                            src={closeIcon}
                            onClick={() => clearImage("parentPicture")}
                          ></img>
                        </div>
                        <div className="signature-img-div">
                          {imageUrl && (
                            <img
                              src={imageBase64}
                              width="70%"
                              height="120px"
                              style={{ zIndex: 1, margin: "auto" }}
                            ></img>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>

            {/* ------------------- */}

            <div className="row d-none">
              {!idCardUrl ? (
                <div className="col-md-6 mt-2">
                  <div className="col-md-6">
                    <label
                      htmlFor="firstname"
                      className="label_text2 text-nowrap font-weight-bold"
                    >
                      Front page of ID card of Parent/Guardian
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <label
                      className="cursor-pointer"
                      htmlFor="parentFrontPageId"
                    >
                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                        {settingIdCardImage ? (
                          <div className="center-v">
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          </div>
                        ) : (
                          <React.Fragment>
                            <p className="label_text">
                              Click or drag <br /> and drop file
                            </p>
                            <img
                              className="img-fluid"
                              src={uploadArrow}
                              alt=""
                            />
                          </React.Fragment>
                        )}
                      </div>
                      <input
                        onChange={(e) =>
                          handleFileUpload(e, "parentFrontPageId")
                        }
                        id="parentFrontPageId"
                        className="input-file-type"
                        type="file"
                        name="file"
                        accept="image/png, image/jpg, image/jpeg"
                      />
                    </label>
                  </div>
                </div>
              ) : (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("parentFrontPageId")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {idCardUrl && (
                          <img
                            src={idCardBase64}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ----------------- */}

              {!minorIdentityUrl ? (
                <div className="col-xl-6">
                  <div className="col-lg-12 ml-n3">
                    <label
                      htmlFor="firstname"
                      className="label_text2 text-nowrap font-weight-bold"
                    >
                      Scanned copy of Minor's Birth certificate/NIN <br />
                      /International passport
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <label className="cursor-pointer" htmlFor="minorIdentity">
                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                        {settingMinorIdentityImage ? (
                          <div className="center-v">
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          </div>
                        ) : (
                          <React.Fragment>
                            <p className="label_text">
                              Click or drag <br /> and drop file
                            </p>
                            <img
                              className="img-fluid"
                              src={uploadArrow}
                              alt=""
                            />
                          </React.Fragment>
                        )}
                      </div>
                      <input
                        onChange={(e) => handleFileUpload(e, "minorIdentity")}
                        id="minorIdentity"
                        className="input-file-type"
                        type="file"
                        name="file"
                        accept="image/png, image/jpg, image/jpeg"
                      />
                    </label>
                  </div>
                </div>
              ) : (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("minorIdentity")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {minorIdentityUrl && (
                          <img
                            src={minorIdentityBase64}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="row d-none">
              {/* --------------- */}

              {!signatureImageUrl ? (
                <div className="col-md-6 mt-2">
                  <div className="col-md-6">
                    <label
                      htmlFor="firstname"
                      className="label_text2 text-nowrap font-weight-bold"
                    >
                      Signature of Parent/Guardian
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <label className="cursor-pointer" htmlFor="parentSignature">
                      <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                        {settingSignatureImage ? (
                          <div className="center-v">
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          </div>
                        ) : (
                          <React.Fragment>
                            <p className="label_text">
                              Click or drag <br /> and drop file
                            </p>
                            <img
                              className="img-fluid"
                              src={uploadArrow}
                              alt=""
                            />
                          </React.Fragment>
                        )}
                      </div>
                      <input
                        onChange={(e) => handleFileUpload(e, "parentSignature")}
                        id="parentSignature"
                        className="input-file-type"
                        type="file"
                        name="file"
                        accept="image/png, image/jpg, image/jpeg"
                      />
                    </label>
                  </div>
                </div>
              ) : (
                <div className="col-md-6">
                  <div className="img-upload-success-div">
                    <div className="close-icon-signature-div">
                      <div className="close-icon-img cursor-pointer">
                        <img
                          src={closeIcon}
                          onClick={() => clearImage("parentSignature")}
                        ></img>
                      </div>
                      <div className="signature-img-div">
                        {signatureImageUrl && (
                          <img
                            src={signatureImageBase64}
                            width="70%"
                            height="120px"
                            style={{ zIndex: 1, margin: "auto" }}
                          ></img>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <FileUpload
                id={"inputTagUtilityBillId"}
                clearImage={() => clearImage("utility-bill")}
                fileUrl={utilityBillImageUrl}
                fileUrlImageBase64={utilityBillImageBase64}
                handleFileUpload={(e) => handleFileUpload(e, "utilityBill")}
                settingFileImageUrl={settingutilityBillImage}
                htmlFor={"inputTagUtilityBillId"}
                tag="Utility Bill"
              />

              <div className="col-xl-6 d-none">
                <div className="col form-group mt-3 ml-n3">
                  <label htmlFor="branch domicilation" className="label_text">
                    Branch of account domiciliation
                    <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={mappedBranches}
                    value={selectedBranch}
                    onChange={handleSelectBranch}
                  />
                </div>
              </div>
            </div>

            <div className="row container mt-3 ml-1 d-none">
              <label htmlFor="branch domicilation" className="label_text mb-3">
                Select value-added services
              </label>

              <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                <label
                  className="custom-control-label pl-3"
                  htmlFor="checkbox3"
                >
                  <b>
                    Debit card (Verve/Mastercard) - Click here, if you do not
                    want a debit card
                  </b>
                </label>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-2">
            <div className="mb-3 mr-4" style={{ marginRight: "20px" }}>
              <button
                onClick={() => {
                  goToStep(accountOpeningSteps.minorDetails);
                }}
                className="btn btn-outline-gold mr-3 btn-filled-white"
              >
                Previous
              </button>
            </div>
            {uploadingMinorDocs ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button
                type="submit"
                className="btn btn-filled-red"
                disabled={
                  !formik.isValid ||
                  !isValidated ||
                  (!isParent && !formik.values.minorIdentityUrl)
                }
              >
                Proceed
              </button>
            )}
          </div>
        </div>
      </form>
      <CustomModal
        show={openSignatureCanvas}
        onClickClose={() => setOpenSignatureCanvas(false)}
      >
        <SignaturePad onClickSave={handleUploadESignature} />
      </CustomModal>
    </div>
  );
}

export default UploadDocumentMinorSavingsDialog;
